import { Map } from 'immutable';
import { connect } from '../../../../../common/react-redux';
import { screenreaderNotification } from '../../../../../common/actions/alerts';
import { createItem } from '../../../../../common/actions/modifications';
import { removeQuizEntry } from '../../../../api/quizEntries';
import { withConfirm } from '../../../../../common/actions/modal';
import { QuizEntryShowPresenter } from './presenter';
import { getQuizEntryWithErrorsShowing } from '../../../../../common/selectors/quizzes';
import { CREATE_ITEM_CALL, UPDATE_ITEM_CALL } from '@instructure/quiz-common';
import { featureOn } from '../../../../../common/util/featureCheck';
function mapStateToProps(state, props) {
  var dndPosition = state.getIn(['dragAndDrop', 'position']);
  var draggingAboveHalf = state.getIn(['dragAndDrop', 'aboveHalf'], false);
  var draggingOver = props.draggingOnBuild && dndPosition === props.quizEntry.position;
  var itemModsClear = state.getIn(['modifications', 'items'], Map()).isEmpty();
  var quizEntryModsClear = state.getIn(['modifications', 'quizEntries'], Map()).isEmpty();
  var richFITBInteraction = state.getIn(['interactionTypes'], Map()).find(function (interactionType) {
    return interactionType.get('slug') === 'rich-fill-blank';
  });
  return {
    createItemCallStatus: state.getIn(['calls', CREATE_ITEM_CALL, 'requestStatus'], ''),
    draggingAboveHalf: draggingOver && draggingAboveHalf,
    draggingOver: draggingOver,
    modificationsClear: itemModsClear && quizEntryModsClear,
    quizEntryWithErrorsShowing: getQuizEntryWithErrorsShowing(state) || props.haveValidationErrorsFromApi,
    richFITBEnabled: featureOn('interaction_type_rich_fill_blank'),
    lockBlueprintContentEnabled: featureOn('lock_blueprint_content'),
    richFITBInteractionID: (richFITBInteraction || Map()).get('id'),
    updateItemCallStatus: state.getIn(['calls', UPDATE_ITEM_CALL, 'requestStatus'], '')
  };
}
var mapDispatchToProps = {
  createItem: createItem,
  removeQuizEntry: removeQuizEntry,
  screenreaderNotification: screenreaderNotification,
  withConfirm: withConfirm
};
export var QuizEntryShow = connect(mapStateToProps, mapDispatchToProps)(QuizEntryShowPresenter);
export default QuizEntryShow;